import React from "react";
import "./App.css";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import StatsStrip from "./components/StatsStrip";
import Manifesto from "./components/Manifesto";
import Music from "./components/Music";
import Marquee from "./components/Marquee";
import CollectorVinyl from "./components/CollectorVinyl";
import Merch from "./components/Merch";
import Socials from "./components/Socials";
import B9Background from "./components/B9Background";
import SmoothScroll from "./components/SmoothScroll";

function App() {
  return (
    <div className="App grain relative" data-testid="app-root">
      <SmoothScroll />
      <B9Background />
      <Nav />
      <main className="relative z-10">
        <Hero />
        <StatsStrip />
        <Manifesto />
        <Music />
        <Marquee items={["BOB9INE", "LOVER BOY 2", "RVA FOREVER", "VINYL OUT NOW", "B9"]} />
        <CollectorVinyl />
        <Merch />
        <Socials />
      </main>
    </div>
  );
}

export default App;
